<template>
  <div class="gantt" v-loading="ganttLoading">
    <template v-if="utasksData && utasksData.length > 0">
      <easy-gantt
        :sdate="sdate"
        :utasks="utasksData"
        :start-time="startTime"
        :end-time="endTime"
        :childHeight="childHeight"
        ref="easyGantt"
        :className="className"
      ></easy-gantt>
    </template>
    <div class="not-data flex-between" v-else>{{ $lange == "en" ? "No Data" : "暂无数据" }}</div>
  </div>
</template>
<style id="ganttStyle">
.at-eg-bd td {
  border-bottom: none !important;
}
</style>
<script>
import EasyGantt from "./gantt/EasyGantt";
import moment from "moment";
import demoData from "./gantt/data.json";
export default {
  name: "gantt",
  watch: {
    utasks: {
      handler() {
        this.initData();
      },
      deep: true
    }
  },
  props: {
    isAssign: {
      //是否是指派
      default: false
    },
    utasks: {
      required: true
    },
    childHeight: {
      //甘特图渲染块的高度
    },
    isStartTime: {
      //传入渲染甘特图的开始时间
    },
    isEndTime: {
      //传入渲染甘特图的结束时间
    },
    isMerge: {
      //是否将任务都覆盖
      default: false
    },
    isAddWeek: {
      //是否在传入的时间前后加7天
      default: false
    },
    className: String,
    endTimeV2:String // 结束日期修正
  },
  data() {
    return {
      ganttLoading: false,
      sdate: null,
      utasksData: null,
      startTime: null,
      endTime: null
    };
  },
  components: {
    EasyGantt
  },
  methods: {
    initData() {
      this.ganttLoading = true;
      this.utasksData = null;
      let data = this.utasks;
      // console.log(this.utasks, "Last Gantt")
      console.log(this.utasks, "this.utasks")
      let newData = {
        items: [],
        sdate: data[0].startTime,
        startTime: "",
        endTime: ""
      };
      let startTime = false;
      let endTime = false;
      /**
       * 先遍历一遍，做为甘特图渲染时间的数据间隔
       *
       * */
      for (let i in data) {
        let newStartTime = new Date(data[i].startTime).getTime();
        let newEndTime = new Date(data[i].endTime).getTime();
        // console.log(duration,newStartTime,newEndTime, "this.utasks")
        // console.log(data[i], "this.utasks")
        if (newStartTime < startTime || startTime === false) {
          startTime = newStartTime;
        }
        if (newEndTime > endTime || endTime === false) {
          endTime = newEndTime;
        }
      }
      newData.startTime = moment(new Date(startTime)).format("YYYY-MM-DD");
      newData.endTime = moment(new Date(endTime)).format("YYYY-MM-DD");
      /**
       * 这一块是为了让甘特图的时间周期，往前跟往后延长7天
       * */
      if (this.isStartTime && this.isStartTime.length > 0) {
        // console.log(this.isAddWeek, "this.isAddWeek")
        if (this.isAddWeek) {
          newData.startTime = moment(
            new Date(this.isStartTime).getTime() - 604800000
          ).format("YYYY-MM-DD");
          // console.log(newData.startTime, "newData.startTime")
        } else {
          newData.startTime = this.isStartTime;
        }
      }
      if (this.isEndTime && this.isEndTime.length > 0) {
        if (this.isAddWeek) {
          newData.endTime = moment(
            new Date(this.isEndTime).getTime() + 604800000
          ).format("YYYY-MM-DD");
          // console.log(newData.endTime, "newData.endTime")
        } else {
          newData.endTime = this.isEndTime;
        }
      }
      /**
       * 遍历数据，做甘特图的title跟颜色
       * 任务指派跟一般情况不太一样，所以做了一个判断
       * isMerge 用于是否启用甘特图衔接合并
       * */
      for (let i in data) {
        let newStartTime = new Date(data[i].startTime).getTime();
        let newEndTime = new Date(data[i].endTime).getTime();
        if (newStartTime < startTime || startTime === false) {
          startTime = newStartTime;
        }
        if (newEndTime > endTime || endTime === false) {
          endTime = newEndTime;
        }
        let workType = 2;
        if (data[i].items === undefined) {
          // console.log(data[i].items, "data[i].itemsdata[i].items")
          workType = 4;
        }
        // console.log(data[i].startTime, "---------------------------")

        if (data[i].items && data[i].items.length > 0) {
          // console.log(this.isMerge)

          if (this.isMerge) {
            let parentStart = data[i].startTime;
            let parentEnd = data[i].endTime;
            for (let j in data[i].items) {
              if (
                new Date(parentStart).getTime() >
                new Date(data[i].items[j].startTime).getTime()
              ) {
                parentStart = data[i].items[j].startTime;
              }
              if (
                new Date(parentEnd).getTime() <
                new Date(data[i].items[j].endTime).getTime()
              ) {
                parentEnd = data[i].items[j].endTime;
              }
            }
            let childDuration =
              moment(parentEnd).diff(moment(parentStart), "days") + 1;
            newData.items.push({
              tasks: [
                {
                  duration: childDuration,
                  sdate: moment(data[i].startTime).format("YYYY-MM-DD"),
                  title: data[i].value,
                  worktype: workType
                }
              ]
            });
          } else {
            let taskArr = [];
            for (let j in data[i].items) {
              if (
                new Date(newData.startTime).getTime() >
                new Date(data[i].items[j].startTime).getTime()
              ) {
                data[i].items[j].startTime = newData.startTime;
                // console.log(`-----${data[i].items[j].startTime}-----`)
              }

              if (data[i].items[j].workType !== undefined) {
                workType = data[i].items[j].workType;
              } else {
                workType = 2;
              }
              let childDuration =
                moment(data[i].items[j].endTime).diff(
                  moment(data[i].items[j].startTime),
                  "days"
                ) + 1;
              // if(childDuration !== 0 || !this.isAssign){
              //     console.log(childDuration, "childDuration")
              //     childDuration += 1;
              // }
              // console.log(data[i].items[j].value, "data[i].items[j].value")
              taskArr.push({
                duration: childDuration,
                sdate: moment(data[i].items[j].startTime).format("YYYY-MM-DD"),
                title: data[i].items[j].value,
                worktype: workType
              });
              console.log( data[i].items[j].value,' data[i].items[j].value')
            }
            newData.items.push({ tasks: taskArr });
          }
        } else {
          /***
           *  这里做的兼容是因为 日期只差一天的时候，甘特图只会渲染一天；比如 2019-01-01 到 2019-01-02; 那么甘特图只会渲染 2019-01-01                         *
           */
          let duration = moment(data[i].endTime).diff(
            moment(data[i].startTime),
            "days"
          );
          if (duration != 0 || !this.isAssign) {
            console.log(duration);
            duration += 1;
          }
          newData.items.push({
            tasks: [
              {
                duration: duration,
                sdate: moment(data[i].startTime).format("YYYY-MM-DD"),
                title: data[i].value,
                worktype: workType
              }
            ]
          });
        }
      }
      // for(let o in newData.items){
      //     // console.log(newData.items[o], "newData.items[o]")
      //     for(let n in newData.items[0].tasks){
      //         console.log(newData.items[0].tasks[n], n, "newData.items[0].tasks");
      //     }
      // }
      // console.log(newData.items, "showGantt11111")
      this.startTime = newData.startTime;
      this.endTime = newData.endTime;
      if(this.endTimeV2){
         this.endTime = this.endTimeV2
      }
      this.sdate = newData.sdate;
      setTimeout(() => {
        this.utasksData = newData.items;
        this.ganttLoading = false;
      }, 300);
      // console.log(newData.items, "Gantt")
    }
  },
  mounted() {
    console.log("childHeight", this.isStartTime, this.isEndTime);
    this.initData();
  }
};
</script>

<style lang="scss">
.gantt {
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
  .not-data {
    height: 96px !important;
  }
}
</style>
